export const EmailConfirmationLogo = () => {
	return (
		<svg
			width="166"
			height="53"
			viewBox="0 0 166 53"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_15611_84285)">
				<path
					d="M68.6719 10.5117H93.9419"
					stroke="#263238"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M39.6797 10.5117H65.3397"
					stroke="#263238"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M26.0078 10.5117H33.8978"
					stroke="#263238"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M46.7578 24.2305H93.8378"
					stroke="#263238"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M33.8984 24.2305H39.6784"
					stroke="#263238"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M67.8281 37.9492H93.7381"
					stroke="#263238"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M41.7891 37.9492H63.9991"
					stroke="#263238"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M64.2812 51.6797H93.6413"
					stroke="#263238"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M49.6797 51.6797H60.1097"
					stroke="#263238"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M150.619 52.1783H77.0391L80.7291 9.98828H154.309L150.619 52.1783Z"
					fill="white"
					stroke="#263238"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M154.314 9.98828H80.7344"
					stroke="#263238"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M150.619 52.1698H77.0391L102.189 28.2898L114.969 39.1898L129.929 28.0898L150.619 52.1698Z"
					fill="white"
					stroke="#263238"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M154.314 9.98828L129.934 28.0883L114.974 39.1883L102.194 28.2883L80.7344 9.98828H154.314Z"
					fill="white"
					stroke="#263238"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M18.97 10.5117H0.5"
					stroke="#263238"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M152.839 20.6202C157.937 20.6202 162.069 16.4877 162.069 11.3902C162.069 6.29257 157.937 2.16016 152.839 2.16016C147.742 2.16016 143.609 6.29257 143.609 11.3902C143.609 16.4877 147.742 20.6202 152.839 20.6202Z"
					fill="#92E3A9"
					stroke="#263238"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M147.492 9.33L152.842 15.35L165.012 0.95L164.582 0.5L152.842 10.6L149.732 7.21L147.492 9.33Z"
					fill="#263238"
					stroke="#263238"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_15611_84285">
					<rect width="165.51" height="52.68" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
